import { get } from "lodash";

/**
 * 向子页面传递信息
 * @param {*} message 要传递的信息
 * @param {string} origin 指明目标接收窗口的源
 */
export const sendMessage = function (message, origin = "*") {
  window.frames.iframe.postMessage(message, origin);
};
/**
 * 向父页面传递信息
 * @param {*} message 要传递的信息
 * @param {string} origin 指明目标接收窗口的源
 */
export const topSendMessage = function (message, origin = "*") {
  window.parent.postMessage(message, origin);
};
/**
 * 监听上级信息
 * @param {function} cbk 回调函数
 * @return event
 */
export const listenMessage = function (cbk) {
  window.addEventListener(
    "message",
    function (e) {
      get(e, "data.type") != "webpackOk" ? cbk(e.data, e) : "";
    },
    false
  );
};



// WEBPACK FOOTER //
// ./src/yx-widget/utils/iframeMessage/basic.js